import { parsePhoneNumberFromString, isValidPhoneNumber, type CountryCode } from 'libphonenumber-js'

export type { CountryCode }

export const DEFAULT_COUNTRY: CountryCode = 'UA'

export function toE164(input: string | null | undefined, defaultCountry: CountryCode = DEFAULT_COUNTRY): string | null {
  if (!input) return null
  const raw = input.trim()
  if (!raw) return null
  // "380671234567" (no plus) is a full international number written the Ukrainian way
  const candidate = /^380\d{9}$/.test(raw.replace(/\D/g, '')) && !raw.startsWith('+') ? `+${raw.replace(/\D/g, '')}` : raw
  const parsed = parsePhoneNumberFromString(candidate, defaultCountry)
  return parsed && parsed.isValid() ? parsed.number : null
}

export function isValidE164(input: string | null | undefined, defaultCountry: CountryCode = DEFAULT_COUNTRY): boolean {
  return !!input && isValidPhoneNumber(input, defaultCountry)
}

export function formatPhoneForDisplay(e164: string | null | undefined): string {
  if (!e164) return ''
  const parsed = parsePhoneNumberFromString(e164)
  return parsed ? parsed.formatInternational() : e164
}
